import { getSetting, setSetting, Setting } from "../../data/local/ls";

export const pagination = {
	data() {
		return {
			tableOptions: {
				page: this.$route.query.page ? Number(this.$route.query.page) : 1,
				itemsPerPage: getSetting(Setting.data_table_page_size) || 10,
				sortBy: ["date"],
				sortDesc: [true],
				groupBy: [],
				groupDesc: [],
				multiSort: false,
				mustSort: false,
			},
			tableFooterProps: {
				showFirstLastPage: true,
				firstIcon: "icon-double-left",
				lastIcon: "icon-double-right",
				itemsPerPageOptions: [5, 10, 15, 20, 50],
			},
			pagination: {
				totalItemCount: 0,
			},
		};
	},
	watch: {
		tableOptions(newValue, oldValue) {
			const pageChanged = newValue.page !== oldValue.page;
			const sizeChanged = newValue.itemsPerPage !== oldValue.itemsPerPage;
			const sortKeyChanged = newValue.sortBy[0] !== oldValue.sortBy[0];
			const sortDirChanged = newValue.sortDesc[0] !== oldValue.sortDesc[0];

			if (this.pagination && (pageChanged || sizeChanged || sortKeyChanged || sortDirChanged)) {
				if (typeof this.loadItems === "function") {
					this.loadItems();
				}
			}

			if (sizeChanged) {
				setSetting(Setting.data_table_page_size, newValue.itemsPerPage);
			}

			if (pageChanged) {
				const query = { ...this.$route.query, page: newValue.page };
				this.$router.replace({ query });
			}
		},
	},
};

const shipmentMethodIcons = {
	sea: "icon-ship",
	aerial: "icon-plane",
	land: "icon-truck",
	railway: "icon-train",
};

export const iconHelper = {
	methods: {
		getShipmentMethodIcon(method, defaultIcon) {
			return shipmentMethodIcons[method] || (defaultIcon !== undefined ? defaultIcon : "icon-shuffle");
		},
	},
};

export const getProformaChipColor = function (status) {
	const colorMap = {
		template: "grey lighten-2",
		revoked: "yellow lighten-4",
		processed: "purple lighten-4",
		rejected: "red lighten-4",
		approved: "green lighten-4",
		pending_approval: "blue lighten-4",
		pending_revise: "orange lighten-4",
	};
	return colorMap[status] || "grey lighten-2";
};

export const getProformaChipTextColor = function (status) {
	const textColorMap = {
		template: "grey darken-4",
		revoked: "grey darken-4",
		processed: "purple darken-2",
		rejected: "red darken-2",
		approved: "green darken-2",
		pending_approval: "blue darken-2",
		pending_revise: "orange darken-2",
	};
	return textColorMap[status] || "grey darken-4";
};

/* --- unit-chip helpers --- */
const UNIT_PALETTE = [
	"red lighten-3",
	"pink lighten-3",
	"purple lighten-3",
	"deep-purple lighten-3",
	"indigo lighten-3",
	"blue lighten-3",
	"teal lighten-3",
	"green lighten-3",
	"lime lighten-3",
	"amber lighten-3",
	"orange lighten-3",
	"deep-orange lighten-3",
];
const hashCode = (str) => {
	let sum = 0;
	for (let i = 0; i < str.length; i++) sum += str.charCodeAt(i);
	return sum % UNIT_PALETTE.length;
};
export const getUnitChipColor = (code) => (code ? UNIT_PALETTE[hashCode(code)] : "grey lighten-2");
export const getUnitChipTextColor = () => "grey darken-4";
